import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';
import DescriptionComponent from './description.component';
import { lineHeight, responsiveFontSize } from 'style';

const DescriptionPlusTextComponent = ({
    descriptionLabel,
    descriptionBody,
    text,
}) => (
    <div className="wrapper" id="DescriptionPlusTextComponent">
    <div className="container-fluid">
        <div className="row">
            <div className="col-xs-12 col-lg-3">
                
            </div>
            <div className="col-xs-12 col-lg-8 col-lg-offset-1">
                <div><strong>{descriptionLabel}</strong></div>
                <div>{descriptionBody}</div><br/>
                <div>{text}</div>
            </div>
        </div>
    </div>
    </div>
);

export default DescriptionPlusTextComponent;
